import React from 'react'
import { cart, map } from '../assets/assets'
import '../styles/d3/humiLab.scss'

export default props => {
  return (
    <div className='humi-lab'>
      <img className='bg-img map' src={map} alt='bg-map' />
      <img className='bg-img cart' src={cart} alt='bg-cart' />
    </div>
  )
}
